<template>
  <div>
    <NBar title="开通年卡" :top="true" :on-click-home="home"/>
    <div class="top-div">
      <img :src='require("@/resource/img/device/card_icon.png")' style="width:55px;height:55px;"/>
      <span style="margin-top: 5px">专享年卡超值价</span>
      <span class="price">{{cardData.price}}元</span>
    </div>
    <div style="margin-bottom: 50px;">
      <img :src='require("@/resource/img/device/year_card_bg.png")' style="width:100%;height:auto;"/>
    </div>
    <nut-button v-if="!cardStatus" @click="pay" block class="bottom-btn"
                style="">
      立即开通
      <nut-price :price="cardData.price" style="color: #4A4A4A;" :decimalDigits="2"
                 :needSymbol="true" :thousands="true" @click="pay"/>
    </nut-button>
    <div class="bottom-div" v-else>
      已开通 {{config.cardEndTime}}到期
    </div>
    <pay v-model="payShow" :price="payData.money" :pay-price="payData.money"
         :pay-type="3" :data="payData" :show-balance="false" :show-card="false" @payOk="payOkCallback"></pay>
  </div>
</template>

<script>
export default {
  name: 'DeviceYearCard',
  data () {
    return {
      user: {},
      config: {},
      payShow: false,
      payData: {},
      cardData: {},
      cardStatus: false
    }
  },
  mounted () {
    this.user = this.$api.user
    this.config = this.$api.user.configCode === 1 ? this.$api.user.config : {}
    if (!this.$util.isArrOrNull(this.config.cardId)) {
      let currentTime = this.$util.formatDate.format(new Date(), 'yyyy/MM/dd')
      currentTime = currentTime.replace(/-/g, '/')
      let endTime = this.$util.formatDate.parse(this.config.cardEndTime, 'yyyy/MM/dd')
      endTime = this.$util.formatDate.format(endTime, 'yyyy/MM/dd')
      endTime = endTime.replace(/-/g, '/')
      let current = new Date(currentTime).getTime() / 1000
      let end = new Date(endTime).getTime() / 1000
      if (end >= current) {
        this.cardStatus = true
      }
    }
    this.getData()
  },
  methods: {
    home () {
      let deviceId = localStorage.getItem('deviceId')
      this.$router.push(`/device/DeviceUse?deviceId=${deviceId}`)
    },
    getData () {
      this.$api.post({
        url: '/device/api/device/device-card/get',
      }).then(res => {
        this.cardData = res.data
      })
    },
    pay () {
      this.payData = {
        uid: this.$api.user.uid,
        money: this.cardData.price,
        cardId: this.cardData.id,
        merId: this.$api.merId,
        storeId: this.$api.storeId,
        agentId: this.$api.agentId
      }
      this.payShow = true
    },
    /**
     * 支付成功回调
     * @param res
     */
    payOkCallback (res) {
      this.payShow = false
    },
  }
}
</script>

<style scoped>
  .top-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 194px;
    background: linear-gradient(180deg, #FFF4DC 0%, #FFFFFF 100%);
  }

  .price {
    color: #E02020;
    font-size: 22px;
    margin-top: 5px;
  }

  .bottom-btn {
    position: fixed;
    bottom: 0;
    margin-top: 10px;
    height: 55px;
    color: #4A4A4A;
    background: linear-gradient(315deg, #FBE76D 0%, #F5CB3B 100%);
  }

  .bottom-div {
    position: fixed;
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    font-size: 15px;
    width: 100%;
    height: 55px;
    color: #F7D349;
    background: #777777;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/use/DeviceYearCard.vue